import type { AssetTypeEntity } from "@/entities/asset-type";

import { useModelLinkInline } from "@/modules/model-link";

export const useAssetTypeTemplateLink = (assetType: AssetTypeEntity) => {
  const templateId = assetType.entity_template_id;
  const sectionLink = useModelLinkInline("technicalform");
  const itemLink = useModelLinkInline("technicalform", { id: templateId });

  if (!templateId || !itemLink) return sectionLink;

  return itemLink;
};
